/**
 * State of the accounts module.
 */
export interface IAccountState {
    /**
     * Current sign up step.
     */
    step: number;

    /**
     * Whether or not Regily registration is currently open.
     */
    isRegilyOpen: boolean;

    /**
     * Whether the user has completed the bank account linking in current session
     */
    hasCompletedBankLinking: boolean;
}

export const ACCOUNT_NAMESPACE = 'account';

export const SET_SIGN_UP_STEP = 'SET_SIGN_UP_STEP';
export const SET_REGILY_OPEN_STATE = 'SET_REGILY_OPEN_STATE';
export const SET_BANK_LINKING_COMPLETION = 'SET_BANK_LINKING_COMPLETION';
